import instance from "@/utils/AxiosUtils";
import {SysApis} from "@/api/SysApis"
import {router} from "@/router";

const commonApi = {
    login(data) {
        return instance({
            url: SysApis.login,
            method: 'post',
            data: data
        })
    },
    logout() {
        sessionStorage.clear()
        localStorage.clear()
        router.push("/login")
        // return instance({
        //     url: SysApis.logout,
        //     method: 'get',
        // })
    },
    getUserInfo() {
        return instance({
            url: SysApis.userInfo,
            method: 'get',
        })
    },
}
export default commonApi
